//lib
import moment from "moment";

// Custom ViewModels
import { PropertyViewModel } from "Custom/ViewModels/DashboardSubViewModels/PropertyViewModel";

// Custom Models
import { ProgressActivityModel } from "Custom/Models/DashboardModels/ProgressActivityModel";

// Utilities
import { isNullOrUndefined } from "util";

// Formats the sales status for a property.
export const formatSalesStatus = (item: PropertyViewModel, salesStatus: ProgressActivityModel, warrantyCountdownInYears: number) => {
    let salesStatusName = "";

    if (salesStatus) salesStatusName = salesStatus.activityName;

    if (!salesStatusName) {
        return formattedCountdownElement("Invalid property", "");
    }

    if (salesStatusName === "10 year warranty") {
        return item.model.legalActualDateUTC
            ? formatWarrantyCountdown(item.model.legalActualDateUTC, warrantyCountdownInYears)
            : formattedCountdownElement("Invalid inspection legal", "");
    }

    return formattedCountdownElement(salesStatusName, "");
};

export const formatSalesStatusLite = (item: PropertyViewModel, warrantyCountdownInYears: number) => {
    if (!item.SalesStatusName) {
        return formattedCountdownElement("Invalid property", "");
    }

    if (item.SalesStatusName === "10 year warranty") {
        return item.model.legalActualDateUTC
            ? formatWarrantyCountdown(item.model.legalActualDateUTC, warrantyCountdownInYears)
            : formattedCountdownElement("Invalid inspection legal", "");
    }

    return formattedCountdownElement(item.SalesStatusName, "");
};

// Formats the 10-year warranty countdown.
const formatWarrantyCountdown = (completedDateString: string, warrantyCountdownInYears: number) => {
    if (!completedDateString) {
        return formattedCountdownElement("Invalid date", "");
    }

    const completedDate = new Date(Date.parse(completedDateString));
    const warrantyExpiryDate = moment(completedDate)
        .add(warrantyCountdownInYears, "years")
        .toDate();

    const monthsTotal = moment(warrantyExpiryDate).diff(moment(), "months");
    const yearsTotal = moment(warrantyExpiryDate).diff(moment(), "years");

    // Calculate the difference in months and years.
    const months = monthsTotal % 12;
    const years = yearsTotal;

    const monthsStringFormatted = months > 0 ? `${months} MONTH${months > 1 ? "S" : ""}` : "";
    const yearsStringFormatted = years > 0 ? `${years} YEAR${years > 1 ? "S" : ""}${months > 0 ? ", " : ""}` : "";

    if (!monthsStringFormatted && !yearsStringFormatted) {
        return formattedCountdownElement("EXPIRED", "");
    }

    return formattedCountdownElement(yearsStringFormatted + monthsStringFormatted, " REMAINING");
};

const formattedCountdownElement = (span1Content: string, span2Content: string) => {
    return span1Content + span2Content;
};
